import styled from 'styled-components';

import { Theme } from '../../theme';
import Body03 from '../typography/Body03';
import Code02 from '../typography/Code02';
import { DAY_STATUS_ENUM } from './helpers';

type StyleProps = {
    isHoliday?: boolean;
    isSelectable?: boolean;
    theme: Theme;
    status?: string;
    withBottomRightBorder?: boolean;
    withoutHover?: boolean;
};

export const DAY_WIDTH = 40;

export const getBGColorOnHover = (props: StyleProps) => {
    const { isSelectable, status, theme } = props;

    if (status === DAY_STATUS_ENUM.SELECTED && isSelectable) {
        return theme.semanticColor.hoverPrimary;
    }

    if (!isSelectable) {
        return theme.semanticColor.highlightSecondary;
    }
    
    return theme.semanticColor.highlightPrimary;
};

export const getBGColor = (props: StyleProps) => {
    const { isSelectable, status, theme } = props;

    if (status === DAY_STATUS_ENUM.SELECTED && isSelectable) {
        return theme.semanticColor.selected;
    }

    if (!isSelectable) {
        return theme.semanticColor.highlightSecondary;
    }

    if (status === DAY_STATUS_ENUM.IN_RANGE) {
        return theme.semanticColor.selectedSemi;
    }

    if (status === DAY_STATUS_ENUM.HOVER || status === DAY_STATUS_ENUM.CURRENT_HOVER) {
        return getBGColorOnHover(props);
    }

    return theme.color.white;
};

export const getColor = (props: StyleProps) => {
    const { status, isHoliday, isSelectable, theme } = props;

    if (isHoliday) {
        return theme.semanticColor.holiday;
    }

    if (status === DAY_STATUS_ENUM.SELECTED && isSelectable) {
        return theme.color.white;
    }

    if (!isSelectable) {
        return theme.semanticColor.textDisabled;
    }

    if (status === DAY_STATUS_ENUM.CURRENT || status === DAY_STATUS_ENUM.CURRENT_HOVER) {
        return theme.semanticColor.primary;
    }

    return theme.semanticColor.textPrimary;
};

export default styled.button<StyleProps>`
    align-items: center;
    background-color: ${ getBGColor };
    border: none;
    cursor: ${ ({ isSelectable }) => {
        return isSelectable ? 'pointer' : 'not-allowed';
    } };
    display: flex;
    flex: 1 0 ${ DAY_WIDTH }px;
    height: ${ DAY_WIDTH }px;
    justify-content: center;
    margin: 0;
    min-width: ${ DAY_WIDTH }px;
    outline: none;
    overflow: hidden;
    padding: 0;
    position: relative;

    &:hover {
        background-color: ${ ({ status, theme, isSelectable, withoutHover }) => !withoutHover && getBGColorOnHover({ status, isSelectable,  theme }) };
    }

    ${ Code02 }, ${ Body03 } {
        color: ${ getColor };
    }

    ${ ({ status, theme }) =>
        (status === DAY_STATUS_ENUM.CURRENT || status === DAY_STATUS_ENUM.CURRENT_HOVER) &&
        `
        &:after {
            background-color: ${ theme.semanticColor.primary };
            bottom: 8px;
            content: '';
            display: block;
            height: 4px;
            left: 50%;
            margin-left: -2px;
            position: absolute;
            width: 4px;
        }
    ` }
`;
